export function monthKey(s) {
  return `${s.year}-${String(s.month + 1).padStart(2, '0')}`;
}
export function getAvailableMonthKeys(availableDates) {
  return new Set(availableDates.map(date => date.slice(0, 7)));
}